import WarpElement from '@warp-ds/elements-core';
import '@warp-ds/elements/components/button';
import '@warp-ds/elements/components/modal';
import { trackClickVerifyEid, trackCancelVerifyEid } from './tracking.js';
import activateI18n from './i18n.js';
import { modalStyles } from './MessagingEidModal.styles.js';
import { renderModal } from './MessagingEidModal.template.js';

class MessagingEidModal extends WarpElement {
    static styles = [WarpElement.styles, modalStyles];

    static get properties() {
        return {
            open: { type: Boolean },
            eidVerificationUrl: { type: String },
            adId: { type: String },
            trackingCategory: { type: String },
            title: { type: String },
            vertical: { type: String },
            locale: { type: String },
            brand: { type: String },
        };
    }

    constructor() {
        super();
        this.open = false;
        this.eidVerificationUrl = '';
        this.adId = '';
        this.trackingCategory = '';
        this.title = '';
        this.vertical = '';
        this.locale = '';
        this.brand = '';
    }

    connectedCallback() {
        super.connectedCallback();
        activateI18n(this.locale);
    }

    _getTrackingData() {
        return {
            adId: this.adId,
            title: this.title,
            trackingCategory: this.trackingCategory,
            vertical: this.vertical,
        };
    }

    _handleCancelVerify() {
        trackCancelVerifyEid(this._getTrackingData());
        this.shadowRoot?.querySelector('w-modal')?.close();
    }

    _handleClickVerify() {
        trackClickVerifyEid(this._getTrackingData());
        window.location.href = this.eidVerificationUrl;
    }

    _handleModalHidden() {
        this.open = false;
        this.dispatchEvent(
            new CustomEvent('modal-hidden', { bubbles: true, composed: true }),
        );
    }

    render() {
        return renderModal(this);
    }
}

customElements.define('messaging-eid-modal', MessagingEidModal);
